module.exports = __webpack_public_path__ + "img/camera_2.cc5ebc1c.jpg";